import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RuntimeEnvService } from './runtime-env.service';

@Injectable({
  providedIn: 'root'
})
export class IndxpProcessorService {

  constructor(
    private http: HttpClient,
    private runtimeEnv: RuntimeEnvService,
  ) { }

  process(request: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const url = `${this.runtimeEnv.url('INDXP')}/process`;
    return this.http.post<any>(url, request, httpOptions);
  }
}
